// Shared server-clock offset. The browser clock can be skewed by seconds; the VR
// betting countdown must count down to Sportradar's absolute, pre-announced
// betstop (UTC epoch) so it stays in lockstep with the official SR player and the
// video's real round start. We derive `offset = serverTime - clientNow` from a
// server-stamped response (the VR timing endpoint carries `serverTime`) and read
// the corrected "now" via serverNow(). Module singleton (no React) so any VR
// countdown component can read it imperatively inside its 1s tick.

let offsetMs = 0;

// Update the offset from an authoritative server timestamp (epoch ms). Called on
// each VR timing fetch, so the offset stays fresh as clock drift accumulates.
export const syncServerClock = (serverTimeMs: number | undefined): void => {
  if (typeof serverTimeMs === "number" && serverTimeMs > 0) {
    offsetMs = serverTimeMs - Date.now();
  }
};

// Server-corrected current time (epoch ms).
export const serverNow = (): number => Date.now() + offsetMs;
